import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";
import SpeakersSettings from "@/components/editor/shared/speakers/speakers-settings/speakers-settings-component";

import SpeakerCard from "./speaker-card/speaker-card-component";
import {
  BackgroundColorWrapper,
  PaddingWrapper,
  SpeakerList,
  StyledFlex,
} from "./speakers-component-styles";

type SpeakersProps = {
  children?: React.ReactNode;
};

export default function Speakers(props: SpeakersProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth="1440px">
          <StyledFlex>
            <Element
              id="speakers-title"
              is={Text}
              element="h2"
              text="Speakers"
              pattern="headingTwo"
            />
          </StyledFlex>
          <SpeakerList>{props.children}</SpeakerList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BackgroundColorWrapper>
  );
}

Speakers.craft = {
  isCanvas: true,
  custom: {
    displayName: "Speakers",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: () => SpeakersSettings({ template: SpeakerCard }),
  },
};
